import { makeDeliveryMethods } from '../../../redux/selectors/checkoutPageSelectors';
import { getCurrentSubmitBillDataByName } from '../../../redux/selectors/transactionDetail';
import { useSelector } from '../../../redux/utils';

export const useData = () => {
  const methods = useSelector(makeDeliveryMethods());
  const selectedMethod = useSelector(
    getCurrentSubmitBillDataByName('delivery_mode')
  );

  return {
    methods,
    selectedMethod,
  };
};
